import { Components } from "appworks/components/components";
import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { PromptContentSubcomponent } from "appworks/components/prompt/prompt-content-subcomponent";
import { Contract } from "appworks/utils/contracts/contract";

/** @deprecated Move to class function */
export function YesNoPromptCommand(prompt: PromptContentSubcomponent, yesUpHandler: () => void, noUpHandler: () => void) {
    return new Contract<boolean>((resolve) => {

        prompt.addContinueButton();
        prompt.addButton("no", () => {
            prompt.hide().execute();
            noUpHandler();
            resolve(false);
        });

        Components.get(PromptComponent).showPrompt(prompt).then(() => {
            prompt.hide().execute();
            yesUpHandler();
            resolve(true);
        });
    });
}
